import { Component, OnInit } from '@angular/core';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { Activity, ActivityCategory, ActivityStatus } from '../../model/activity';
import { Partner } from '../../model/partner';

import * as jsPDF from 'jspdf';

import * as html2canvas from 'html2canvas';

declare var $: any;

@Component({
  selector: 'app-customers-report',
  templateUrl: './customers-report.component.html',
  styleUrls: ['./customers-report.component.css'],
  providers: [DBService]
})
export class CustomersReportComponent implements OnInit {

  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  initialDate: number;
  initialDateString: string;

  endDate: number;
  endDateString: string;

  companyFilter: string;

  companies: Company[];
  displayCompanies: Company[];

  loading: boolean;

  emptyData: boolean;

  totalAmount: number;
  activeCount: number;
  activeAmount: number;
  inactiveCount: number;
  inactiveAmount: number;

  constructor(private dbService: DBService) {
    this.displayCompanies = [];
    this.companyFilter = '0';
    this.initialDateString = '';
    this.endDateString = '';

    this.emptyData = true;
    this.loadCompanies();
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.companies = companies;
      });
  }

  search() {
    this.loading = true;

    this.emptyData = false;

    this.displayCompanies = this.companies
      .filter(c => c.contractDate >= this.initialDate)
      .filter(c => c.contractDate <= this.endDate)
      .sort((p1, p2) => p2.fee - p1.fee);

    this.totalAmount = this.displayCompanies.reduce((c1, c2) => c1 + c2.fee, 0);

    const actives = this.displayCompanies.filter(c => !c.isInactive);

    const inactives = this.displayCompanies.filter(c => c.isInactive);

    this.activeAmount = actives.reduce((c1, c2) => c1 + c2.fee, 0);

    this.inactiveAmount = inactives.reduce((c1, c2) => c1 + c2.fee, 0);

    this.activeCount = actives.length;
    this.inactiveCount = inactives.length;

    this.loading = false;
  }

  ngOnInit() {
    $( function() {
      $( ".datePicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        nextText: 'Proximo',
        prevText: 'Anterior'
      });
    } );
  }


  async delay(ms: number) {
      await new Promise(resolve => setTimeout(()=>resolve(), ms));
  }

  onChangeStartDate(event) {

    this.delay(1000).then(any => {
    
      this.initialDateString = event.target.value;
      const dateParts = this.initialDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.initialDate;
      } else {
        this.initialDate = date.getTime();
      }

    });

  }

  onChangeEndDate(event) {

    this.delay(1000).then(any => { 

      this.endDateString = event.target.value;
      const dateParts = this.endDateString.split('/');

      const date = new Date(dateParts[1] + '-' + dateParts[0] + '-' + dateParts[2]);

      if (date.toString() === 'Invalid Date') {
        delete this.endDate;
      } else {
        this.endDate = date.getTime();
      }

    });
    
  }

  exportPDF() {
    html2canvas(document.getElementById('content'), { width: 750, height: 915 }).then((canvas) => {
      const img = canvas.toDataURL('image/jpeg');
      const doc = new jsPDF('p', 'mm', 'a4');
      const width = doc.internal.pageSize.width;
      const height = doc.internal.pageSize.height;
      doc.addImage(canvas, 'JPEG', 0, 0, 208, 275);
      doc.save(`Relatório de Licitações.pdf`);
  });
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/customers-report/customers-report.component.ts